import { ArrowBack } from '@mui/icons-material'
import { Typography } from '@mui/material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import BrodcastFormProgress from '../../../Alarm/Broadcast/components/BrodcastFormProgress';
import Button from 'packages/novous_web/src/common/components/Button';
import SubscriptionFormFleet from './SubscriptionFormFleet';

const NewSubscription = () => {
    const navigate = useNavigate();
    const steps = ['Customer Selection', 'Order Details', 'Summary'];
    const [activeStep, setActiveStep] = useState(0);
    const [isSummaryView, setIsSummaryView] = useState(false);
    
    const handleActiveState = (step: number) => {
        setActiveStep(step);
        setIsSummaryView(step === 2);
    }
    
    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1);
            setIsSummaryView(activeStep - 1 === 2);
        } else {
            navigate(-1);
        }
    };
    
    return (
        <div className='flex flex-col gap-4 w-full h-full'>
            <div className="w-full mb-4">
                <CustomIconButton
                    icon={<ArrowBack />}
                    text="Back"
                    background="transparent"
                    onClick={handleBack}
                />
            </div>
            <div className='w-full flex flex-col gap-4 mb-4 h-full'>
                <div className="w-full">
                    <div className="dashboard-header-left flex items-center justify-between">
                        <div className="flex flex-col items-start">
                            <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                                {isSummaryView ? 'Summary' : 
                                 activeStep === 0 ? 'Add New Subscription' : 'Add New Subscription'}
                            </Typography>
                        </div>
                        {isSummaryView && (
                            <Button
                                text='Edit Orders'
                                onClick={() => {
                                    setIsSummaryView(false);
                                    handleActiveState(1);
                                }}
                                fullWidth={false}
                            />
                        )}
                    </div>
                </div>
                <div className="flex justify-center items-center w-full">
                    <div className="flex w-[50%] border rounded-lg items-center border-gray-300 p-2 justify-center">
                        <BrodcastFormProgress steps={steps} activeStep={activeStep} />
                    </div>
                </div>
                <SubscriptionFormFleet
                    handleActiveState={handleActiveState}
                    isSummaryView={isSummaryView}
                    setIsSummaryView={setIsSummaryView}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                />
            </div>
        </div>
    )
}

export default NewSubscription